"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5413],{

/***/ 37526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var AngleDown = function AngleDown(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M24.7 28.633L40 43.9l15.3-15.267 4.7 4.7-20 20-20-20 4.7-4.7z",
      fill: "#fff"
    })
  }));
};

var MemoAngleDown = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(AngleDown);
/* harmony default export */ __webpack_exports__["Z"] = (MemoAngleDown);

/***/ }),

/***/ 1919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var HeartFull = function HeartFull(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 73 68",
    fill: "none"
  }, props), {}, {
    style: {
      filter: 'drop-shadow(0px 2.4px 4.8px rgba(0, 0, 0, 0.25))'
    },
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M51.151.25c-4.737 0-7.791.578-11.292 2.335a20.126 20.126 0 00-3.642 2.346 20.55 20.55 0 00-3.496-2.239C29.153.883 25.941.25 21.374.25 9.14.25.25 10.638.25 24.129c0 10.189 5.543 20.03 15.869 29.547 5.42 4.996 12.34 9.94 17.295 12.57l2.836 1.504 2.836-1.505c4.955-2.63 11.875-7.573 17.295-12.569C66.707 44.16 72.25 34.319 72.25 24.13 72.25 10.781 63.276.302 51.151.25z",
      fill: "#FF3A3A"
    })
  }));
};

var MemoHeartFull = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(HeartFull);
/* harmony default export */ __webpack_exports__["Z"] = (MemoHeartFull);

/***/ }),

/***/ 82334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Pause = function Pause(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 180 180",
    fill: "none"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("g", {
      filter: "url(#prefix__filter0_d_5327_9905)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M70.586 43h-4.862C60.354 43 56 47.23 56 52.45v75.6c0 5.219 4.354 9.45 9.724 9.45h4.862c5.37 0 9.724-4.231 9.724-9.45v-75.6c0-5.22-4.354-9.45-9.724-9.45zM114.344 43h-4.862c-5.37 0-9.724 4.23-9.724 9.45v75.6c0 5.219 4.354 9.45 9.724 9.45h4.862c5.37 0 9.724-4.231 9.724-9.45v-75.6c0-5.22-4.354-9.45-9.724-9.45z"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("defs", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("filter", {
        id: "prefix__filter0_d_5327_9905",
        x: 53.761,
        y: 41.822,
        width: 72.546,
        height: 98.978,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feOffset", {
          dy: 1.061
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feGaussianBlur", {
          stdDeviation: 1.119
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_5327_9905"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_5327_9905",
          result: "shape"
        })]
      })
    })]
  }));
};

var MemoPause = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(Pause);
/* harmony default export */ __webpack_exports__["Z"] = (MemoPause);

/***/ }),

/***/ 43935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var Play = function Play(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 180 180",
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M131.617 83.25L80.955 44.5C75.392 40.228 67.5 44.27 67.5 51.289v77.422c0 7.018 7.892 11.061 13.455 6.789l50.662-38.75c4.51-3.28 4.51-10.144 0-13.5z",
      fill: "#fff"
    })
  }));
};

var MemoPlay = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(Play);
/* harmony default export */ __webpack_exports__["Z"] = (MemoPlay);

/***/ }),

/***/ 18958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useFavorites; }
/* harmony export */ });
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50029);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _store_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4062);
/* harmony import */ var app_model_category__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51027);
/* harmony import */ var app_store_slices_user__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38886);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var services_hooks_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90413);
/* harmony import */ var _navigation_hook__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26793);









var useFavorites = function useFavorites(customAuthGuard) {
  var dispatch = (0,_store_store__WEBPACK_IMPORTED_MODULE_1__/* .useAppDispatch */ .TL)();
  var navigatePath = (0,_navigation_hook__WEBPACK_IMPORTED_MODULE_5__/* .useNavigatePath */ .xQ)();

  var _useAppSelector = (0,_store_store__WEBPACK_IMPORTED_MODULE_1__/* .useAppSelector */ .CG)(app_store_slices_user__WEBPACK_IMPORTED_MODULE_2__/* .selectUserState */ .tH),
      session = _useAppSelector.session,
      favorites = _useAppSelector.favorites,
      favoritesLoading = _useAppSelector.favoritesLoading;

  var _usePostAccountUsersM = (0,services_hooks_hooks__WEBPACK_IMPORTED_MODULE_4__/* .usePostAccountUsersMePresets */ .Ww)(),
      addFavorite = _usePostAccountUsersM.mutateAsync,
      addToFavoriteLoading = _usePostAccountUsersM.isLoading;

  var _useDeleteAccountUser = (0,services_hooks_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useDeleteAccountUsersMePresets */ .$$)(),
      deleteFavorite = _useDeleteAccountUser.mutateAsync,
      deleteFavoriteLoading = _useDeleteAccountUser.isLoading;

  var favoritesPending = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function () {
    return favoritesLoading || addToFavoriteLoading || deleteFavoriteLoading;
  }, [favoritesLoading || addToFavoriteLoading || deleteFavoriteLoading]);

  var addToFavorites = /*#__PURE__*/function () {
    var _ref = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(category) {
      var isPlaying,
          _args = arguments;
      return _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isPlaying = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
              _context.prev = 1;
              _context.next = 4;
              return addFavorite({
                requestBody: [{
                  permalink: category.permalink
                }],
                queryParams: {
                  live: isPlaying
                }
              });

            case 4:
              dispatch(app_store_slices_user__WEBPACK_IMPORTED_MODULE_2__/* .userActions.loadFavorites */ .hI.loadFavorites());
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 7]]);
    }));

    return function addToFavorites(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var removeFromFavorites = /*#__PURE__*/function () {
    var _ref2 = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(category) {
      var isPlaying,
          _args2 = arguments;
      return _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              isPlaying = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
              _context2.prev = 1;
              _context2.next = 4;
              return deleteFavorite({
                queryParams: {
                  live: isPlaying
                },
                requestBody: [{
                  permalink: category.permalink
                }]
              });

            case 4:
              dispatch(app_store_slices_user__WEBPACK_IMPORTED_MODULE_2__/* .userActions.loadFavorites */ .hI.loadFavorites());
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](1);
              console.error(_context2.t0);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 7]]);
    }));

    return function removeFromFavorites(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var isFavoriteCategory = function isFavoriteCategory(category) {
    return !!(0,app_model_category__WEBPACK_IMPORTED_MODULE_7__/* .findCategory */ .b5)(favorites || [], category);
  };

  var toggleFavorite = /*#__PURE__*/function () {
    var _ref3 = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(category) {
      var isPlaying,
          _args3 = arguments;
      return _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              isPlaying = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : false;

              if (!(session !== null && session !== void 0 && session.user)) {
                _context3.next = 5;
                break;
              }

              if (!favoritesPending) {
                if (isFavoriteCategory(category)) {
                  removeFromFavorites(category, isPlaying);
                } else {
                  addToFavorites(category, isPlaying);
                }
              }

              _context3.next = 11;
              break;

            case 5:
              if (!customAuthGuard) {
                _context3.next = 10;
                break;
              }

              _context3.next = 8;
              return customAuthGuard();

            case 8:
              _context3.next = 11;
              break;

            case 10:
              navigatePath('/log-in');

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function toggleFavorite(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  return {
    toggleFavorite: toggleFavorite,
    isFavoriteCategory: isFavoriteCategory,
    loading: favoritesPending,
    addToFavorites: addToFavorites,
    removeFromFavorites: removeFromFavorites
  };
};

/***/ }),

/***/ 51027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZH": function() { return /* binding */ getStationLiveLogo; },
/* harmony export */   "b5": function() { return /* binding */ findCategory; },
/* harmony export */   "n6": function() { return /* binding */ getArtistName; },
/* harmony export */   "tw": function() { return /* binding */ getStationTitle; }
/* harmony export */ });
var findCategory = function findCategory(categories, category) {
  return categories.find(function (categoryItem) {
    return categoryItem.permalink === category.permalink;
  });
};
var getStationLiveLogo = function getStationLiveLogo(metadata, fallback) {
  var _metadata$body;

  if (metadata !== null && metadata !== void 0 && (_metadata$body = metadata.body) !== null && _metadata$body !== void 0 && _metadata$body.content) {
    var _metadata$body2, _metadata$body2$conte, _metadata$body2$conte2, _metadata$body4, _metadata$body4$conte, _metadata$body4$conte2, _metadata$body4$conte3, _metadata$body6, _metadata$body6$conte, _metadata$body6$conte2;

    if ((_metadata$body2 = metadata.body) !== null && _metadata$body2 !== void 0 && (_metadata$body2$conte = _metadata$body2.content) !== null && _metadata$body2$conte !== void 0 && (_metadata$body2$conte2 = _metadata$body2$conte.track) !== null && _metadata$body2$conte2 !== void 0 && _metadata$body2$conte2.cover) {
      var _metadata$body3, _metadata$body3$conte, _metadata$body3$conte2;

      return (_metadata$body3 = metadata.body) === null || _metadata$body3 === void 0 ? void 0 : (_metadata$body3$conte = _metadata$body3.content) === null || _metadata$body3$conte === void 0 ? void 0 : (_metadata$body3$conte2 = _metadata$body3$conte.track) === null || _metadata$body3$conte2 === void 0 ? void 0 : _metadata$body3$conte2.cover;
    }

    if ((_metadata$body4 = metadata.body) !== null && _metadata$body4 !== void 0 && (_metadata$body4$conte = _metadata$body4.content) !== null && _metadata$body4$conte !== void 0 && (_metadata$body4$conte2 = _metadata$body4$conte.track) !== null && _metadata$body4$conte2 !== void 0 && (_metadata$body4$conte3 = _metadata$body4$conte2.album) !== null && _metadata$body4$conte3 !== void 0 && _metadata$body4$conte3.cover) {
      var _metadata$body5, _metadata$body5$conte, _metadata$body5$conte2, _metadata$body5$conte3;

      return (_metadata$body5 = metadata.body) === null || _metadata$body5 === void 0 ? void 0 : (_metadata$body5$conte = _metadata$body5.content) === null || _metadata$body5$conte === void 0 ? void 0 : (_metadata$body5$conte2 = _metadata$body5$conte.track) === null || _metadata$body5$conte2 === void 0 ? void 0 : (_metadata$body5$conte3 = _metadata$body5$conte2.album) === null || _metadata$body5$conte3 === void 0 ? void 0 : _metadata$body5$conte3.cover;
    }

    if ((_metadata$body6 = metadata.body) !== null && _metadata$body6 !== void 0 && (_metadata$body6$conte = _metadata$body6.content) !== null && _metadata$body6$conte !== void 0 && (_metadata$body6$conte2 = _metadata$body6$conte.show) !== null && _metadata$body6$conte2 !== void 0 && _metadata$body6$conte2.logo) {
      var _metadata$body7, _metadata$body7$conte, _metadata$body7$conte2;

      return (_metadata$body7 = metadata.body) === null || _metadata$body7 === void 0 ? void 0 : (_metadata$body7$conte = _metadata$body7.content) === null || _metadata$body7$conte === void 0 ? void 0 : (_metadata$body7$conte2 = _metadata$body7$conte.show) === null || _metadata$body7$conte2 === void 0 ? void 0 : _metadata$body7$conte2.logo;
    }
  }

  return fallback;
};
var getStationTitle = function getStationTitle(metadata, stationName) {
  var _metadata$body8, _metadata$body8$conte, _metadata$body8$conte2, _metadata$body10, _metadata$body10$cont, _metadata$body10$cont2;

  if ((_metadata$body8 = metadata.body) !== null && _metadata$body8 !== void 0 && (_metadata$body8$conte = _metadata$body8.content) !== null && _metadata$body8$conte !== void 0 && (_metadata$body8$conte2 = _metadata$body8$conte.show) !== null && _metadata$body8$conte2 !== void 0 && _metadata$body8$conte2.name) {
    var _metadata$body9, _metadata$body9$conte, _metadata$body9$conte2;

    return "".concat(stationName, " - ").concat((_metadata$body9 = metadata.body) === null || _metadata$body9 === void 0 ? void 0 : (_metadata$body9$conte = _metadata$body9.content) === null || _metadata$body9$conte === void 0 ? void 0 : (_metadata$body9$conte2 = _metadata$body9$conte.show) === null || _metadata$body9$conte2 === void 0 ? void 0 : _metadata$body9$conte2.name);
  } else if ((_metadata$body10 = metadata.body) !== null && _metadata$body10 !== void 0 && (_metadata$body10$cont = _metadata$body10.content) !== null && _metadata$body10$cont !== void 0 && (_metadata$body10$cont2 = _metadata$body10$cont.track) !== null && _metadata$body10$cont2 !== void 0 && _metadata$body10$cont2.name) {
    var _metadata$body11, _metadata$body11$cont, _metadata$body11$cont2;

    return "".concat(stationName, " - ").concat((_metadata$body11 = metadata.body) === null || _metadata$body11 === void 0 ? void 0 : (_metadata$body11$cont = _metadata$body11.content) === null || _metadata$body11$cont === void 0 ? void 0 : (_metadata$body11$cont2 = _metadata$body11$cont.track) === null || _metadata$body11$cont2 === void 0 ? void 0 : _metadata$body11$cont2.name);
  } else {
    return stationName;
  }
};
var getArtistName = function getArtistName(metadata) {
  var _metadata$body12;

  if ((_metadata$body12 = metadata.body) !== null && _metadata$body12 !== void 0 && _metadata$body12.content) {
    var _metadata$body13, _metadata$body13$cont, _metadata$body13$cont2, _metadata$body13$cont3;

    if ((_metadata$body13 = metadata.body) !== null && _metadata$body13 !== void 0 && (_metadata$body13$cont = _metadata$body13.content) !== null && _metadata$body13$cont !== void 0 && (_metadata$body13$cont2 = _metadata$body13$cont.track) !== null && _metadata$body13$cont2 !== void 0 && (_metadata$body13$cont3 = _metadata$body13$cont2.artist) !== null && _metadata$body13$cont3 !== void 0 && _metadata$body13$cont3.name) {
      var _metadata$body14, _metadata$body14$cont, _metadata$body14$cont2, _metadata$body14$cont3;

      return (_metadata$body14 = metadata.body) === null || _metadata$body14 === void 0 ? void 0 : (_metadata$body14$cont = _metadata$body14.content) === null || _metadata$body14$cont === void 0 ? void 0 : (_metadata$body14$cont2 = _metadata$body14$cont.track) === null || _metadata$body14$cont2 === void 0 ? void 0 : (_metadata$body14$cont3 = _metadata$body14$cont2.artist) === null || _metadata$body14$cont3 === void 0 ? void 0 : _metadata$body14$cont3.name;
    }
  }
};

/***/ })

}]);